module.exports = __webpack_public_path__ + "static/placeholder-d580fc2f096c3106d0f33f01c1310dd1.svg";